module.exports = __webpack_public_path__ + "images/background/image/3-fc8e9e62c31fa268c5883c852b144db7.jpg";